import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../common/ui/Button'
import Filter from '../../common/icons/Filter'

const FilterResultsIcon = ({onClick, showLabel, className = ""}) => (
  <Button
    className    = {`plain filter-results-icon ${showLabel ? 'show-label' : ''}${className}`}
    clickHandler = {onClick}
    role         = "button"
  >
    { showLabel && <span className="filter-results-title">Filter</span> }
    <Filter />
  </Button>
)

FilterResultsIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  showLabel: PropTypes.bool,
  className: PropTypes.string
}

export default FilterResultsIcon